import { File } from './file.model'

export class FileTag {
    id: number;
    key: string;
    meta: string;
    temp: boolean;
    value: number;
    file: File;

    constructor(data) {
        this.id = data.id;
        this.key = data.key;
        this.meta = data.meta;
        this.temp = data.temp;
        this.value = data.value;
        this.file = new File(data.file);
    }
}
